import React, { memo } from 'react';
import { useIntl } from 'react-intl';

import { ContentContainer } from '~/eds/src/components/ContentContainer/ContentContainer';

import { BaseDocumentViewerProps } from './types/viewer';

export const UnsupportedDocumentViewer = memo(
  ({ file }: BaseDocumentViewerProps) => {
    const intl = useIntl();

    const fileType = file?.type;

    return (
      <ContentContainer
        placeholderContent={{
          icon: 'status-warning',
          title: intl.formatMessage({
            id: 'UnsupportedDocumentViewer.title',
            defaultMessage: 'Unsupported document type',
            description: 'Title for unsupported document type error',
          }),
          message: intl.formatMessage(
            {
              id: 'UnsupportedDocumentViewer.message',
              defaultMessage:
                'This document type "{fileType}" is not supported.',
              description:
                'Message explaining that the document type is not supported. Example: fileType = ".xyz"',
            },
            { fileType },
          ),
        }}
      />
    );
  },
);
